/*
 * HONEYWELL INC.,
 * COPYRIGHT (c) 2022
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */

import React, { memo, useContext } from 'react';
import { useTranslation } from '@scuf/localization';
import descriptors from '../../../../../locales/en-US/descriptors';
import {
  EnergyDetailMeterField,
  PreferredUnit,
  EnergyUsageUtilityType
} from '../../../../shared/Utils/Constants';
import { IDataTableColumn } from '../../../../shared/MeterSavingsDetailTable/IMeterSavingsDetailTableProps';
import { convertDataForEnergyUsagesSavingsMeter } from '../../../../shared/Utils/EnergyUsagesViewDetailsUtils';
import CarbonDetailTabBreakdownByMeter from '../../../../shared/DetailBreakdownByMeter/CarbonDetailTabBreakdownByMeter';
import {
  IEmaasEnergyUsageComponentData,
  IEnergyMeter
} from '../../../../DashboardKPIWidgets/IEnergyManagementProps';
import './EnergyScopeSavingsByMeterDetail.scss';
import { ApiContext } from '../../../../../context/ApiContext';
import { ConversionType } from '../../../../../main';

export interface IEnergyScopeSavingsByMeterDetailComponentProps {
  data: IEmaasEnergyUsageComponentData;
  UtilityBillType: string;
  sourceType?: string;
}

export const energyScopeSavingsByMeterDetailComponent = (
  props: IEnergyScopeSavingsByMeterDetailComponentProps
) => {
  const [t] = useTranslation();
  const d = descriptors.energyManagement;
  const {
    data: { energyMeasurementUnit, breakdownByMeter, sourceType },
    UtilityBillType
  } = props;
  const apiContext = useContext(ApiContext);
  const { userPreferedUnit } = apiContext;

  let fromUnit: string;
  // if (true) {
  //   fromUnit = userPreferedUnit as any;
  // } else {
  //   fromUnit = energyMeasurementUnit;
  // }

  fromUnit =
    props.data.sourceType && props.data.sourceType.toLowerCase() === 'water'
      ? PreferredUnit.Water
      : userPreferedUnit === 'megajoule'
      ? userPreferedUnit
      : props.data.sourceType === ConversionType.GAS
      ? apiContext.toggleEnableKwhGas
        ? PreferredUnit.Electricity
        : PreferredUnit.Gas
      : (PreferredUnit.Electricity as any);

  const { values, displayUnit } = convertDataForEnergyUsagesSavingsMeter(
    breakdownByMeter as IEnergyMeter[],
    energyMeasurementUnit,
    fromUnit,
    apiContext.showChangeWhenData
  );

  const columnDetails: Array<IDataTableColumn> = [
    {
      className: 'datatable-column-meter',
      field: EnergyDetailMeterField.meter,
      header: t(d.METER),
      sortable: true,
      initialWidth: '30%'
    },
    {
      className: 'datatable-column-actualConsumption',
      field: EnergyDetailMeterField.actualConsumption,
      header: t(d.actualCost),
      sortable: true,
      initialWidth: '40%'
    },
    {
      className: 'datatable-column-baselineConsumption',
      field: EnergyDetailMeterField.baselineConsumption,
      header: t(d.PREVIOUSPERIOD),
      sortable: true,
      initialWidth: '15%'
    },
    {
      className: 'datatable-column-change',
      field: EnergyDetailMeterField.change,
      header: t(d.CHANGE),
      sortable: true,
      initialWidth: '15%'
    }
  ];

  return (
    <div className="emaas-Metersaving-details-head">
      {UtilityBillType === EnergyUsageUtilityType.Water && (
        <div className="water-breakdown-by-meter-heading">
          {t(d.WATERBREAKDOWNBYLIVEMETERS)}
        </div>
      )}
      <CarbonDetailTabBreakdownByMeter
        meterData={values}
        utilityMeasurementUnit={displayUnit}
        columnDetails={columnDetails}
        utilityType={UtilityBillType}
        isEnergy={true}
        emissionMeasurementUnit={energyMeasurementUnit}
        sourceType={sourceType}
      />
    </div>
  );
};
export default memo(energyScopeSavingsByMeterDetailComponent);
